SNI.Application.addModule('flyout-menu', context => {
  return {
    behaviors: ['horizontal-scroll']
  };
});
